import { defaultAd300x250, IAdUnit } from "../unit";

export enum MobileHomepageScrollEnum {
  MobileHomepageScroll1 = "Mobile Homepage Scroll 1",
  MobileHomepageScroll2 = "Mobile Homepage Scroll 2",
  MobileHomepageScroll3 = "Mobile Homepage Scroll 3",
  MobileHomepageScroll4 = "Mobile Homepage Scroll 4",
  MobileHomepageScroll5 = "Mobile Homepage Scroll 5",
  MobileHomepageScroll6 = "Mobile Homepage Scroll 6",
  MobileHomepageScroll7 = "Mobile Homepage Scroll 7",
  MobileHomepageScroll8 = "Mobile Homepage Scroll 8",
  MobileHomepageScroll9 = "Mobile Homepage Scroll 9",
  MobileHomepageScroll10 = "Mobile Homepage Scroll 10",
}

export const MobileHomepageScrollUnits: { [name in MobileHomepageScrollEnum]: IAdUnit } = {
  [MobileHomepageScrollEnum.MobileHomepageScroll1]: {
    ...defaultAd300x250,
    sid: "1232716",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll2]: {
    ...defaultAd300x250,
    sid: "1232717",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll3]: {
    ...defaultAd300x250,
    sid: "1232718",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll4]: {
    ...defaultAd300x250,
    sid: "1232719",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll5]: {
    ...defaultAd300x250,
    sid: "1232720",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll6]: {
    ...defaultAd300x250,
    sid: "1232721",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll7]: {
    ...defaultAd300x250,
    sid: "1232722",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll8]: {
    ...defaultAd300x250,
    sid: "1232723",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll9]: {
    ...defaultAd300x250,
    sid: "1232724",
  },
  [MobileHomepageScrollEnum.MobileHomepageScroll10]: {
    ...defaultAd300x250,
    sid: "1232725",
  },
};
